/* global debounce */
if (!customElements.get('cart-tax-id')) {
  class CartTaxId extends HTMLElement {
    constructor() {
      super();
      this.disclosure = this.closest('details');

      if (this.disclosure && this.disclosure.matches('.cart-tax-id-disclosure')) {
        this.CartTaxIdToggle = this.disclosure.querySelector('.js-show-tax-id');
      }

      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.init();
    }

    init() {
      this.debouncedHandleTaxIdChange = debounce(this.handleTaxIdChange.bind(this), 300);
      // Save as soon as possible, avoid link-click not providing time to save
      this.addEventListener('input', this.debouncedHandleTaxIdChange);
    }

    handleTaxIdChange(evt) {
      if (this.CartTaxIdToggle) {
        const label = evt.target.value ? 'Edit Tax ID' : 'Add Tax ID';
        if (this.CartTaxIdToggle.textContent !== label) this.CartTaxIdToggle.textContent = label;
      }

      this.fetchRequestOpts.body = JSON.stringify({
        attributes: { "tax-id": evt.target.value }
      });
      
      fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
    }
  }

  customElements.define('cart-tax-id', CartTaxId);
}
